namespace TR {
    class RatingFilter {
        model: any;
        aggregate: any;
        range: any;

        constructor(
            private $scope: ng.IScope,
            broker: any
        ) {
            this.$scope.$watch('rf.aggregate', this.setRange.bind(this), true);
            $scope.$watch('rf.model', m => {
                if (m === null) { this.reset(); }
            });
            broker.subscribe('ratingFilter', 'RESETRATING', this.reset.bind(this));

            $scope.$on('$destroy', () => {
                broker.unsubscribe('ratingFilter');
            });
        }

        setRange(a) {
            if (!a) { return; }
            this.range = this.model
                ? { Min: this.model.Min, Max: this.model.Max }
                : { Min: a.Min, Max: a.Max };
        }

        updateModel() {
            // if model already in sync skip
            if (this.model && (this.model.Min === this.range.Min)) {
                return;
            }

            // if new value is the default one reset
            if (this.range.Min === this.aggregate.Min) {
                return this.model = null;
            }

            return this.model = { Min: this.range.Min, Max: this.range.Max };
        }

        isSet() {
            return !!this.model;
        }

        reset() {
            this.range = { Min: this.aggregate.Min, Max: this.aggregate.Max };
            this.model = null;
        }


    }

    angular
        .module('TR')
        .directive('ratingFilter', (): ng.IDirective => {
            return {
                scope: {},
                templateUrl: 'partials/home/directivetemplate?type=RatingFilter',
                bindToController: {
                    aggregate: '=',
                    model: '='
                },
                controller: RatingFilter,
                controllerAs: 'rf'
            };
        });

    class RatingFilterLabel {

        public static getTemplate() {
            return `
                <span ng-if="rf.isSet()">
                    <a
                        href="#"
                        class="filter-criterion-toggle"
                        ng-click="rf.remove()">
                        <span> {{rf.getName()}} </span>
                    </a>
                </span>
            `;
        }

        model: any;
        aggregate: any;
        sentence: string;

        constructor($scope: ng.IScope, private broker: any, analytics: any) {
            $scope.$watch('rf.model', (value: any) => {
                if (!value) { return; }
                analytics.track('mixpanel', 'HolidayDealsFilterRating');
            });
        }

        getName() {
            return this.sentence.replace('{0}', this.model.Min);
        }

        isSet() {
            return !!this.model && this.model.Min > this.aggregate.Min;
        }

        remove(dest) {
            this.broker.publish('RESETRATING');
        }
    }

    angular
        .module('TR')
        .directive('ratingFilterLabel', (): ng.IDirective => {
            return {
                scope: {},
                template: RatingFilterLabel.getTemplate(),
                bindToController: {
                    aggregate: '=',
                    model: '=',
                    sentence: '@'
                },
                controller: RatingFilterLabel,
                controllerAs: 'rf'
            };
        });

}
